import { useState } from 'react';
import { message } from 'antd';
import { Shipment, ShipmentStatus } from '../types';

export const useShipmentSelection = (maxSelect: number | null = 50) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectedShipmentStatuses, setSelectedShipmentStatuses] = useState<
    Record<string, ShipmentStatus | undefined>
  >({});
  const [checked, setChecked] = useState<boolean>(false);

  const handleSelect = (
    shipmentId: string,
    isCheckedFlag: boolean,
    card: Shipment
  ) => {
    if (isCheckedFlag) {
      if (typeof maxSelect === 'number' && selectedIds.length >= maxSelect) {
        message.error(`You can select a maximum of ${maxSelect} shipments`);
        return;
      }

      setSelectedIds((prev) => {
        if (prev.includes(shipmentId)) return prev;
        return [...prev, shipmentId];
      });

      setSelectedShipmentStatuses((prev) => ({
        ...prev,
        [shipmentId]: card?.status ?? null,
      }));
    } else {
      setSelectedIds((prev) => prev.filter((id) => id !== shipmentId));
      setSelectedShipmentStatuses((prev) => {
        const updated = { ...prev };
        delete updated[shipmentId];
        return updated;
      });
    }
  };

  return {
    selectedIds,
    setSelectedIds,
    selectedShipmentStatuses,
    setSelectedShipmentStatuses,
    checked,
    setChecked,
    handleSelect,
  };
};
